import {TaskResponseBody} from '@dms/api/core';

import {WorkshopActivityListItem} from './transformWorkshopActivityItem';

export const transformTaskToWorkshopActivity = (
  task: TaskResponseBody,
  interestId: string
): WorkshopActivityListItem => ({
  id: task.id,
  interestId,
  activityType: 'TASK_CREATED',
  userId: task.createdBy,
  timestamp: task.dueTo ?? task.dueDate ?? task.createdAt,
  reasonCloseCodeId: null,
  reasonCloseNote: null,
  relatedRecordId: task.id,
  relatedResourceId: 'TASK',
  description: task.title,
  subject: null,
  relatedRecord: {
    id: task.id,
    title: task.title,
    priority: task.priority,
    type: task.type,
    state: task.state,
    assignedTo: task.assignedTo,
    dueDate: task.dueDate,
    dueFrom: task.dueFrom,
    dueTo: task.dueTo,
    finishedAt: task.finishedAt,
    description: task.description,
  },
});
